import { ChevronSmallDownIcon } from '../../icons/index.js';

const MuiAutocompleteOverrides = {
  MuiAutocomplete: {
    defaultProps: {
      disableCloseOnSelect: false,
      disableClearable: true,
      size: 'medium',
      ChipProps: {
        color: 'blue',
        size: 'medium'
      },
      slotProps: {
        popupIndicator: {
          component: ChevronSmallDownIcon
        },
        paper: {
          elevation: 8
        }
      }
    },
    styleOverrides: {
      tag: {
        margin: 0
      },
      endAdornment: _ref => {
        let {
          theme
        } = _ref;
        return {
          marginRight: theme.spacing(1)
        };
      },
      option: _ref2 => {
        let {
          theme
        } = _ref2;
        return {
          ...theme.typography.body01
        };
      },
      input: {
        '&.MuiInput-input': {
          padding: 0
        }
      },
      inputRoot: _ref3 => {
        let {
          theme
        } = _ref3;
        return {
          padding: theme.spacing(1.25),
          gap: theme.spacing(1),
          '&.MuiInputBase-adornedStart .MuiSvgIcon-root': {
            marginLeft: -2,
            marginRight: theme.spacing(0.5)
          },
          '.MuiInputAdornment-root:not(.MuiChip-deleteIcon)': {
            marginRight: 0
          },
          '.MuiInputAdornment-root .MuiSvgIcon-root': {
            margin: 0
          }
        };
      }
    }
  }
};

export { MuiAutocompleteOverrides };
